import { PlusCircle, RefreshCcw } from "lucide-react";
import { Button } from "../ui/button";
import { Card, CardContent } from "../ui/card";

interface ProjectEmptyStateProps {
	onCreateProject: () => void;
	onRefresh?: () => void;
	isLoading?: boolean;
}

export function ProjectEmptyState({
	onCreateProject,
	onRefresh,
	isLoading,
}: ProjectEmptyStateProps) {
	return (
		<Card className="border-dashed">
			<CardContent className="py-10 flex flex-col items-center gap-4 text-center">
				<div className="space-y-2">
					<p className="text-lg font-semibold">Add your first project</p>
					<p className="text-muted-foreground text-sm">
						Projects group API keys and metrics. Create one to continue.
					</p>
				</div>
				<div className="flex gap-2">
					<Button onClick={onCreateProject} disabled={isLoading}>
						<PlusCircle className="h-4 w-4 mr-2" /> Add project
					</Button>
					{onRefresh ? (
						<Button variant="outline" onClick={onRefresh} disabled={isLoading}>
							<RefreshCcw className="h-4 w-4 mr-2" /> Refresh
						</Button>
					) : null}
				</div>
			</CardContent>
		</Card>
	);
}
